var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"base-button",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('img',{attrs:{"src":require("@/assets/img/google-g-logo.png"),"alt":"Google Login"}}),_vm._t("default",function(){return [_vm._v("Continuar com "),_c('strong',[_vm._v("Google")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }